import { useState } from "react";
import api from "@/api/client";
import { X, Save } from "lucide-react";

export default function EditInfoModal({ user, onClose, onSaved }) {
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const save = async () => {
    setBusy(true); setErr("");
    try {
      await api.patch("/auth/me", {
        name: name.trim(),
        email: email.trim() || null,
        phone: phone.trim() || null,
      });
      onSaved?.();
    } catch (e) {
      setErr(e?.response?.data?.detail || "فشل حفظ التعديلات");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="edit-info-modal">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}/>
      <div className="relative bg-white rounded-3xl w-full max-w-md p-5 talabya-shadow-float animate-fade-up">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-black text-lg" style={{fontFamily:"Cairo"}}>تعديل المعلومات</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[var(--surface-alt)] flex items-center justify-center" data-testid="close-edit"><X size={16}/></button>
        </div>

        <label className="block text-xs font-bold text-[var(--text-secondary)] mb-1">الاسم الكامل</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none"
          data-testid="input-name"
        />

        <label className="block text-xs font-bold text-[var(--text-secondary)] mt-3 mb-1">البريد الإلكتروني <span className="text-[10px] text-[var(--text-secondary)]">(اختياري)</span></label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          dir="ltr"
          type="email"
          className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none"
          placeholder="example@mail.com"
          data-testid="input-email"
        />

        <label className="block text-xs font-bold text-[var(--text-secondary)] mt-3 mb-1">رقم الهاتف</label>
        <input
          value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/[^\d+]/g, ""))}
          dir="ltr"
          inputMode="tel"
          placeholder="09xxxxxxxx"
          className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none"
          data-testid="input-phone"
        />
        <p className="text-[10px] text-[var(--text-secondary)] mt-1">صيغة الرقم الليبي: 09xxxxxxxx (10 أرقام).</p>

        {err && <div className="mt-3 text-sm bg-red-50 text-red-600 px-3 py-2 rounded-lg" data-testid="edit-err">{err}</div>}

        <div className="mt-5 flex gap-2">
          <button onClick={onClose} className="flex-1 py-3 rounded-xl bg-[var(--surface-alt)] text-[var(--text-secondary)] font-bold">إلغاء</button>
          <button onClick={save} disabled={busy || !name.trim()} className="flex-1 py-3 rounded-xl bg-primary-brand text-white font-black disabled:opacity-60 flex items-center justify-center gap-2" data-testid="save-info">
            <Save size={15}/> {busy ? "جاري الحفظ..." : "حفظ"}
          </button>
        </div>
      </div>
    </div>
  );
}
